import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import TextInput from "../../widgets/TextInput";
import addInsegnante from "../../services/addInsegnante";
import FixButton from "../../widgets/Button";
import Utils from "../../utils/utils";
import addUtente from "../../services/addUtente";

export default class AddInsegnante extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			nome: "",
			cognome: "",
		};

		this.pageTitle = "Aggiungi insegnante";
	}

	lockedSaveInsegnante = Utils.disallowConcurrency(this.save.bind(this));

	render() {
		return (
			<>
				<LoadingOverlay
					active={this.state.isLoading}
					styles={{
						content: base => ({
							position: "relative",
							width: "100%",
							top: "200px",
						}),
					}}
					spinner
					text={"Loading your content..."}
				>
					<PageTitle title={this.pageTitle} />
					<TextInput
						name={"Nome"}
						value={this.state.nome}
						onChange={text => {
							this.setState({ nome: text });
						}}
					/>
					<TextInput
						name={"Cognome"}
						value={this.state.cognome}
						onChange={text => {
							this.setState({ cognome: text });
						}}
					/>
					<br />
					<FixButton title={"Salva"} callback={this.state.isLoading ? () => {} : this.lockedSaveInsegnante} />
					<br />
					<br />
					<br />
					<br />
					<br />
					<br />
				</LoadingOverlay>
			</>
		);
	}

	async save() {
		if (this.state.nome.trim() !== "" && this.state.cognome.trim() !== "") {
			this.setState({ isLoading: true });
			const cookies = new Cookies();
			const username = cookies.get("username", { path: "/" });
			const token = cookies.get("token", { path: "/" });

			let ret = await addInsegnante(username, token, this.state.cognome, this.state.nome);

			var newUsername = await Utils.generateUsername(username, token, this.state.nome, this.state.cognome);
			var password = Utils.generatePassword();
			await addUtente(username, token, "", "", newUsername, password, 2, ret.id);

			if (ret.result === "ok") {
				this.setState({ isLoading: false });
				window.location.href = "/#/app/insegnanti";
			} else {
				this.setState({ isLoading: false });
				alert("Si è verificato un errore durante la creazione del nuovo insegnante. Per favore, riprova.");
			}
		} else {
			alert("Verifica di aver inserito il nome e il cognome prima.");
		}
	}
}
